
// This file is auto-generated by fetchTokensFromFigma.ts
export default {
  "matas": {
    "text": {
      "primary": {
        "neutral": "#1a1a1aff",
        "club-1": "#ffffffff",
        "club-2": "#000000e5",
        "campaign-1": "#1a1a1aff",
        "campaign-2": "#ffffffff",
        "campaign-3": "#ffffffff",
        "sun": "#000000cc",
        "christmas": "#ffffffff",
        "black-friday": "#ffffffff",
        "default": "#1a1a1aff"
      },
      "primaryInverted": {
        "neutral": "#1a1a1aff",
        "club-1": "#ffffffff",
        "club-2": "#000000e5",
        "campaign-1": "#1a1a1aff",
        "campaign-2": "#ffffffff",
        "campaign-3": "#ffffffff",
        "sun": "#000000cc",
        "christmas": "#ffffffff",
        "black-friday": "#ffffffff",
        "default": "#1a1a1aff"
      },
      "secondary": {
        "neutral": "#0d0f13c2",
        "club-1": "#ffffffb2",
        "club-2": "#000000cc",
        "campaign-1": "#1a1a1aff",
        "campaign-2": "#ffffffff",
        "campaign-3": "#ffffffff",
        "sun": "#00000099",
        "christmas": "#ffffffff",
        "black-friday": "#ffffffff",
        "default": "#0d0f13c2"
      },
      "secondaryInverted": {
        "neutral": "#0d0f13c2",
        "club-1": "#ffffffb2",
        "club-2": "#000000cc",
        "campaign-1": "#1a1a1aff",
        "campaign-2": "#ffffffff",
        "campaign-3": "#ffffffff",
        "sun": "#00000099",
        "christmas": "#ffffffff",
        "black-friday": "#ffffffff",
        "default": "#0d0f13c2"
      },
      "disabled": {
        "neutral": "#131d3c66",
        "club-1": "#0000004d",
        "club-2": "#0000004d",
        "campaign-1": "#0000004d",
        "campaign-2": "#ffffff80",
        "campaign-3": "#ffffff4d",
        "sun": "#0000004d",
        "christmas": "#0000004d",
        "black-friday": "#ffffff4d",
        "default": "#131d3c66"
      },
      "sale": {
        "neutral": "#131d3c66",
        "club-1": "#0000004d",
        "club-2": "#0000004d",
        "campaign-1": "#0000004d",
        "campaign-2": "#ffffff80",
        "campaign-3": "#ffffff4d",
        "sun": "#0000004d",
        "christmas": "#0000004d",
        "black-friday": "#ffffff4d",
        "default": "#131d3c66"
      },
      "fixedPrice": {
        "neutral": "#131d3c66",
        "club-1": "#0000004d",
        "club-2": "#0000004d",
        "campaign-1": "#0000004d",
        "campaign-2": "#ffffff80",
        "campaign-3": "#ffffff4d",
        "sun": "#0000004d",
        "christmas": "#0000004d",
        "black-friday": "#ffffff4d",
        "default": "#131d3c66"
      }
    },
    "icon": {
      "primary": {
        "neutral": "#1a1a1aff",
        "club-1": "#ffffffff",
        "club-2": "#000000ff",
        "campaign-1": "#1a1a1aff",
        "campaign-2": "#ffffffff",
        "campaign-3": "#ffffffff",
        "sun": "#000000cc",
        "christmas": "#ffffffff",
        "black-friday": "#ffffffff",
        "default": "#1a1a1aff"
      },
      "secondary": {
        "neutral": "#0d0f13c2",
        "club-1": "#ffffffb2",
        "club-2": "#000000b2",
        "campaign-1": "#ffffffff",
        "campaign-2": "#3285f9ff",
        "campaign-3": "#4d67ffff",
        "sun": "#ffffffff",
        "christmas": "#f90935ff",
        "black-friday": "#000000e5",
        "default": "#0d0f13c2"
      },
      "disabled": {
        "neutral": "#3c4d8133",
        "club-1": "#00000033",
        "club-2": "#00000033",
        "campaign-1": "#00000033",
        "campaign-2": "#ffffff33",
        "campaign-3": "#ffffff33",
        "sun": "#00000033",
        "christmas": "#00000033",
        "black-friday": "#ffffff33",
        "default": "#3c4d8133"
      }
    },
    "border": {
      "primary": {
        "neutral": "#0e183680",
        "club-1": "#3285f9ff",
        "club-2": "#795a2480",
        "campaign-1": "#0064feff",
        "campaign-2": "#ffffffff",
        "campaign-3": "#ffffff80",
        "sun": "#00000066",
        "christmas": "#ffffffb2",
        "black-friday": "#ffffffff",
        "default": "#0e183680"
      },
      "secondary": {
        "neutral": "#3c4d8133",
        "club-1": "#daebffff",
        "club-2": "#795a244d",
        "campaign-1": "#0049db4d",
        "campaign-2": "#ffffff4d",
        "campaign-3": "#0049db80",
        "sun": "#cc8f024d",
        "christmas": "#ff5b6eff",
        "black-friday": "#ffffff66",
        "default": "#3c4d8133"
      },
      "tertiary": {
        "neutral": "#344d981a",
        "club-1": "#0049db1a",
        "club-2": "#344d981a",
        "campaign-1": "#344d981a",
        "campaign-2": "#344d981a",
        "campaign-3": "#344d981a",
        "sun": "#344d981a",
        "christmas": "#344d981a",
        "black-friday": "#344d981a",
        "default": "#344d981a"
      },
      "disabled": {
        "neutral": "#3c4d8133",
        "club-1": "#3c4d8133",
        "club-2": "#3c4d8133",
        "campaign-1": "#0049db1a",
        "campaign-2": "#ffffff1a",
        "campaign-3": "#ffffff33",
        "sun": "#00000033",
        "christmas": "#0000001a",
        "black-friday": "#ffffff33",
        "default": "#3c4d8133"
      },
      "focusRing": {
        "neutral": "#1a1a1aff",
        "club-1": "#1a1a1aff",
        "club-2": "#1a1a1aff",
        "campaign-1": "#1a1a1aff",
        "campaign-2": "#1a1a1aff",
        "campaign-3": "#1a1a1aff",
        "sun": "#1a1a1aff",
        "christmas": "#1a1a1aff",
        "black-friday": "#1a1a1aff",
        "default": "#1a1a1aff"
      }
    },
    "bg": {
      "primary": {
        "neutral": "#f7f8fbff",
        "club-1": "#0064feff",
        "club-2": "#e1d1b4ff",
        "campaign-1": "#daebffff",
        "campaign-2": "#0064feff",
        "campaign-3": "#08009dff",
        "sun": "#fff59bff",
        "christmas": "#e40332ff",
        "black-friday": "#000000ff",
        "default": "#ffffffff"
      },
      "secondary": {
        "neutral": "#ffffffff",
        "club-1": "#0047d6ff",
        "club-2": "#f0e8daff",
        "campaign-1": "#c5dfffff",
        "campaign-2": "#0047d6ff",
        "campaign-3": "#000078ff",
        "sun": "#fff59bff",
        "christmas": "#bd0229ff",
        "black-friday": "#202021ff",
        "default": "#f7f8fbff"
      },
      "tertiary": {
        "neutral": "#344d981a",
        "club-1": "#0000000d",
        "club-2": "#795a241a",
        "campaign-1": "#0049db1a",
        "campaign-2": "#0000001a",
        "campaign-3": "#ffffff33",
        "sun": "#cc8f021a",
        "christmas": "#0000001a",
        "black-friday": "#ffffff1a",
        "default": "#344d981a"
      },
      "inverse": {
        "neutral": "#1a1a1aff",
        "club-1": "#ffffffff",
        "club-2": "#e1d1b4ff",
        "campaign-1": "#0064feff",
        "campaign-2": "#ffffffff",
        "campaign-3": "#ffffffff",
        "sun": "#000000cc",
        "christmas": "#ffffffff",
        "black-friday": "#ffffffff",
        "default": "#1a1a1aff"
      },
      "disabled": {
        "neutral": "#344d981a",
        "club-1": "#344d981a",
        "club-2": "#344d981a",
        "campaign-1": "#344d981a",
        "campaign-2": "#ffffff0d",
        "campaign-3": "#00000033",
        "sun": "#cc8f021a",
        "christmas": "#0000001a",
        "black-friday": "#ffffffff",
        "default": "#344d981a"
      }
    }
  },
  "kicks": {
    "text": {
      "primary": {
        "neutral": "#161616ff",
        "club-1": "#161616ff",
        "club-2": "#161616ff",
        "campaign-1": "#ffffffff",
        "campaign-2": "#000000e5",
        "campaign-3": "#000000e5",
        "sun": "#000000e5",
        "christmas": "#000000e5",
        "black-friday": "#ffffffff",
        "default": "#161616ff"
      },
      "secondary": {
        "neutral": "#0d0f13c2",
        "club-1": "#161616ff",
        "club-2": "#161616ff",
        "campaign-1": "#ffffffff",
        "campaign-2": "#000000e5",
        "campaign-3": "#000000e5",
        "sun": "#000000e5",
        "christmas": "#000000e5",
        "black-friday": "#ffffffff",
        "default": "#0d0f13c2"
      },
      "disabled": {
        "neutral": "#131d3c66",
        "club-1": "#0000004d",
        "club-2": "#0000004d",
        "campaign-1": "#ffffff66",
        "campaign-2": "#0000004d",
        "campaign-3": "#0000004d",
        "sun": "#0000004d",
        "christmas": "#0000004d",
        "black-friday": "#ffffff4d",
        "default": "#131d3c66"
      }
    },
    "icon": {
      "primary": {
        "neutral": "#161616ff",
        "club-1": "#161616ff",
        "club-2": "#161616ff",
        "campaign-1": "#ffffffff",
        "campaign-2": "#000000e5",
        "campaign-3": "#000000e5",
        "sun": "#000000e5",
        "christmas": "#000000e5",
        "black-friday": "#ffffffff",
        "default": "#161616ff"
      },
      "secondary": {
        "neutral": "#0d0f13c2",
        "club-1": "#161616ff",
        "club-2": "#161616ff",
        "campaign-1": "#ffffffff",
        "campaign-2": "#000000e5",
        "campaign-3": "#000000e5",
        "sun": "#000000e5",
        "christmas": "#000000e5",
        "black-friday": "#ffffffff",
        "default": "#0d0f13c2"
      },
      "disabled": {
        "neutral": "#3c4d8133",
        "club-1": "#3c4d8133",
        "club-2": "#00000033",
        "campaign-1": "#ffffff33",
        "campaign-2": "#00000033",
        "campaign-3": "#00000033",
        "sun": "#00000033",
        "christmas": "#00000033",
        "black-friday": "#ffffff33",
        "default": "#3c4d8133"
      }
    },
    "border": {
      "primary": {
        "neutral": "#0e183680",
        "club-1": "#00000080",
        "club-2": "#0e183680",
        "campaign-1": "#0e183680",
        "campaign-2": "#0e183680",
        "campaign-3": "#0e183680",
        "sun": "#0e183680",
        "christmas": "#0e183680",
        "black-friday": "#0e183680",
        "default": "#0e183680"
      },
      "secondary": {
        "neutral": "#3c4d8133",
        "club-1": "#3c4d8133",
        "club-2": "#3c4d8133",
        "campaign-1": "#3c4d8133",
        "campaign-2": "#3c4d8133",
        "campaign-3": "#3c4d8133",
        "sun": "#3c4d8133",
        "christmas": "#3c4d8133",
        "black-friday": "#3c4d8133",
        "default": "#3c4d8133"
      },
      "tertiary": {
        "neutral": "#344d981a",
        "club-1": "#344d981a",
        "club-2": "#344d981a",
        "campaign-1": "#344d981a",
        "campaign-2": "#344d981a",
        "campaign-3": "#344d981a",
        "sun": "#344d981a",
        "christmas": "#344d981a",
        "black-friday": "#344d981a",
        "default": "#344d981a"
      },
      "disabled": {
        "neutral": "#3c4d8133",
        "club-1": "#3c4d8133",
        "club-2": "#3c4d8133",
        "campaign-1": "#3c4d8133",
        "campaign-2": "#3c4d8133",
        "campaign-3": "#3c4d8133",
        "sun": "#3c4d8133",
        "christmas": "#3c4d8133",
        "black-friday": "#3c4d8133",
        "default": "#3c4d8133"
      },
      "focusRing": {
        "neutral": "#161616ff",
        "club-1": "#161616ff",
        "club-2": "#161616ff",
        "campaign-1": "#161616ff",
        "campaign-2": "#161616ff",
        "campaign-3": "#161616ff",
        "sun": "#161616ff",
        "christmas": "#161616ff",
        "black-friday": "#161616ff",
        "default": "#161616ff"
      }
    },
    "bg": {
      "primary": {
        "neutral": "#f7f8fbff",
        "club-1": "#3bd1cdff",
        "club-2": "#3bd1cdff",
        "campaign-1": "#9a43ffff",
        "campaign-2": "#f44ab7ff",
        "campaign-3": "#f44ab7ff",
        "sun": "#ffebd4ff",
        "christmas": "#ff0000ff",
        "black-friday": "#000000ff",
        "default": "#ffffffff"
      },
      "secondary": {
        "neutral": "#ffffffff",
        "club-1": "#62e6deff",
        "club-2": "#62e6deff",
        "campaign-1": "#892af3ff",
        "campaign-2": "#fa6ccbff",
        "campaign-3": "#fa6ccbff",
        "sun": "#ffd3a8ff",
        "christmas": "#ff2323ff",
        "black-friday": "#202021ff",
        "default": "#f7f8fbff"
      },
      "tertiary": {
        "neutral": "#344d981a",
        "club-1": "#cdfaf4ff",
        "club-2": "#cdfaf4ff",
        "campaign-1": "#761ad6ff",
        "campaign-2": "#ffffff1a",
        "campaign-3": "#ffffff1a",
        "sun": "#ffb470ff",
        "christmas": "#ff575780",
        "black-friday": "#ffffff1a",
        "default": "#344d981a"
      },
      "inverse": {
        "neutral": "#1a1a1aff",
        "club-1": "#127173ff",
        "club-2": "#127173ff",
        "campaign-1": "#e7d3ffff",
        "campaign-2": "#c61077ff",
        "campaign-3": "#c61077ff",
        "sun": "#000000ff",
        "christmas": "#ffffffff",
        "black-friday": "#ffffffff",
        "default": "#1a1a1aff"
      },
      "disabled": {
        "neutral": "#344d981a",
        "club-1": "#19b3b11a",
        "club-2": "#19b3b11a",
        "campaign-1": "#761ad61a",
        "campaign-2": "#e31f931a",
        "campaign-3": "#e31f931a",
        "sun": "#fff6edff",
        "christmas": "#ff57571a",
        "black-friday": "#0000001a",
        "default": "#344d981a"
      }
    }
  }
}
